module.exports = __webpack_public_path__ + "media/images/card/glyph-2-9541c9b203f03f9221c4711da16183b5.svg";